import React, { useState } from "react";
import { TextField, Tooltip } from "@mui/material";
import {
  LIMITATION_TYPES,
  LIMITATIONS,
} from "../../../utils/static/limitation";
import { TextFieldForViewOnly } from "./TextField";

const LimitedTextField = ({
  limitationType = LIMITATION_TYPES.ONLY_NUMBERS,
  value,
  onChange,
  warningMessage,
  reference,
  maxValue,
  textAlign = "center",
  disabled = false,
  canEdit = true,
}) => {
  const [warning, setWarning] = useState(false);

  const { allowedChars, maxLength } =
    LIMITATIONS[limitationType] || LIMITATIONS.ALPHANUMERIC;

  const handleChange = (event) => {
    setWarning(false);
    const inputValue = event.target.value;

    // Allow only valid characters based on regex
    const regex = new RegExp(`^[${allowedChars}]{0,${maxLength}}$`);
    if (!regex.test(inputValue)) {
      setWarning(true);
      return;
    }

    // Convert to number for validation
    const numericValue = Number(inputValue);

    // Validate against maxValue
    if (
      maxValue !== undefined &&
      maxValue !== null &&
      numericValue > maxValue
    ) {
      setWarning(true);
      return;
    }

    // Call the parent onChange function
    onChange(numericValue, reference);
  };

  if (!canEdit) {
    return <TextFieldForViewOnly value={value} />;
  }

  return (
    <Tooltip
      title={warning ? warningMessage || `Value cannot exceed ${maxValue}` : ""}
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: "red", // Red background
            color: "white", // White text
          },
        },
      }}
    >
      <TextField
        value={value}
        onChange={handleChange}
        inputProps={{
          maxLength: maxLength,
          style: { textAlign: textAlign },
          autoComplete: "off",
        }}
        variant='outlined'
        error={warning}
        size='small'
        disabled={disabled}
        sx={{ backgroundColor: "white" }}
      />
    </Tooltip>
  );
};

export default LimitedTextField;
